// MARK://dhk8/admin-shell/lib/env
// Build-time flags read once. Mirrors the POS app's seed-preview.PREVIEW_STUB seam:
//   VITE_API_STUB=1  → every client returns deterministic mock data instead of
//                      hitting a backend (so the admin runs with no services up,
//                      e.g. compose.preview.yml).
//   VITE_DEV_LOGIN=1 → the login page shows an "Entrar (modo demo · sin backend)"
//                      shortcut that seeds a fake owner+superadmin session.

export const PREVIEW_STUB = (import.meta.env['VITE_API_STUB'] as string | undefined) === '1'
export const DEV_LOGIN = (import.meta.env['VITE_DEV_LOGIN'] as string | undefined) === '1'
export const BUILD_HASH = (import.meta.env['VITE_BUILD_HASH'] as string | undefined) ?? 'dev'

/** Tiny helper: resolve a value with a short artificial delay (so mock screens
 *  exercise loading states). */
export function mock<T>(value: T, ms = 180): Promise<T> {
  return new Promise((resolve) => setTimeout(() => resolve(structuredClone(value)), ms))
}
